const isSupportedNetwork = ({ walletConnector, network }) => {
    const evmNetworks = walletConnector.evmNetworks || [];
    /**
     * Currently only supports EVM networks. But this could support other types of networks in the future.
     * When this happens, network could be a string (solana) or a number (ethereum). Be sure to remove the Number() cast.
     * when this happens.
     */
    const currentEvmNetwork = evmNetworks === null || evmNetworks === void 0 ? void 0 : evmNetworks.find((element) => element.chainId === Number(network));
    return !(evmNetworks && evmNetworks.length && !currentEvmNetwork);
};

export { isSupportedNetwork };
